import { checkIfSelectionValid, checkIfGroupedSelectionValid } from "@learningblocks/protocol-constants/lib/Utilities";
// set a question option as selected
export function selectQuestionOption(state, payload) {
  return {
    ...state,
    currentSection: updateSelectedOptionInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function updateSelectedOptionInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: updateSelectedOptionInComponents(
      currentSection.components,
      payload
    ),
  };
}

function updateSelectedOptionInComponents(components, payload) {
  const updateComponent = (component) => {
    if (
      component.id === payload.componentID &&
      component.hasOwnProperty("options")
    ) {
      return updateOptionsInComponent(component, payload);
    } else if (
      component.id === payload.componentID &&
      component.hasOwnProperty("typedOptions")
    ) {
      return updateTypedOptionsInComponent(component, payload);
    } else if (
      component.id === payload.componentID &&
      payload.optionGroup === 1 &&
      component.hasOwnProperty("groupedOptions1")
    ) {
      return updateOptions1InComponent(component, payload);
    } else if (
      component.id === payload.componentID &&
      payload.optionGroup === 2 &&
      component.hasOwnProperty("groupedOptions2")
    ) {
      return updateOptions2InComponent(component, payload);
    } else {
      return component;
    }
  };
  return components.map(updateComponent);
}

function updateOptionsInComponent(CSCQComponent, payload) {
  if (checkIfSelectionValid(CSCQComponent)) {
    CSCQComponent.options = CSCQComponent.options.map((option) =>
      updateOption(option, payload)
    );
  }
  return CSCQComponent;
}

function updateOptions1InComponent(CSCQComponent, payload) {
  if (checkIfGroupedSelectionValid(CSCQComponent, CSCQComponent.groupedOptions1.some(option => option.selected && option.disabled && CSCQComponent.answerId[payload.key][0] === option.id))) {
    CSCQComponent.groupedOptions1 = CSCQComponent.groupedOptions1.map(
      (option) => updateOption(option, payload)
    );
    CSCQComponent.latestSelections.groupedOptions1 = payload.optionID
  }
  return CSCQComponent;
}

function updateOptions2InComponent(CSCQComponent, payload) {
  if (checkIfGroupedSelectionValid(CSCQComponent, CSCQComponent.groupedOptions2.some(option => option.selected && option.disabled && CSCQComponent.answerId[payload.key][1] === option.id))) {
    CSCQComponent.groupedOptions2 = CSCQComponent.groupedOptions2.map(
      (option) => updateOption(option, payload)
    );
    CSCQComponent.latestSelections.groupedOptions2 = payload.optionID
  }
  return CSCQComponent;
}

function updateTypedOptionsInComponent(CSCQComponent, payload) {
  if (checkIfSelectionValid(CSCQComponent)) {
    CSCQComponent.typedOptions = CSCQComponent.typedOptions.map((option) =>
      updateOption(option, payload)
    );
  }
  return CSCQComponent;
}

function updateOption(option, payload) {
  if (option.disabled === false || payload.reset) {
    if (payload.optionID === option.id) {
      option.selected = true;
    } else {
      option.selected = false;
      if(payload.reset){
        option.disabled = false;
      }
    }
  }
  return { ...option };
}
